import { createContext } from 'react';

type ChipContextProps = {
  clickable?: boolean;
  disabled?: boolean;
  readonly?: boolean;
};

export const ChipContext = createContext({} as ChipContextProps);